import React from 'react';
import Logo from 'components/ui/icon/Logo';
import Nav from '../Nav';
import Container from 'components/layout/Container';
import {CenterContainer} from '../CentrContainer/CenterContainer';

import './header.scss';

const Header = () => {
  return (
    <CenterContainer className={'center-container'}>
      <header className="header">
        <Container>
          <div className="header__wrapper">
            <Logo />
            <Nav />
          </div>
        </Container>
      </header>
    </CenterContainer>
  );
};

export default Header;
